import React from 'react';
import './floating-widget.scss';
import { motion, AnimatePresence } from 'framer-motion';
import { fadeVariant } from '../../animations/common.variants';
import closeIcon from '../../static/close.svg';


function FloatingWidget({ bodyText = '', ctaText = '', ctaCallback = () => {}, enableCloseButton = false, onCloseButtonClick = () => {}, ...props }) {

    return (
        <AnimatePresence>
            <motion.div className='floating-widget-wrapper'
               
                {...props} >

                    { enableCloseButton && <img src={closeIcon} onClick={onCloseButtonClick} className='close'/> }
                    <span className='body'> {bodyText} </span>
                    { ctaText && <span className='cta' onClick={ctaCallback}> {ctaText} </span> }
                    
            </motion.div>
        </AnimatePresence>
    );
}

export default FloatingWidget;  